import React from 'react';
import Accordion from '../../../../../../../../components-new/ui/Accordion';
import AccordionItem from '../../../../../../../../components-new/ui/Accordion/AccordionItem';
import Translate from '../../../../../../../../components/Translate';
import CircleQuestionMarkIcon from '../../../../../../../../assets/icons/CircleQuestionMarkIcon';
import MinusIcon from '../../../../../../../../assets/icons/MinusIcon';
import PlusIcon from '../../../../../../../../assets/icons/PlusIcon';
import colors from '../../../../../../../../utils/Colors';

/*
 * "Integration steps" - a channel's instructions, folded away until wanted.
 *
 * Messenger, Instagram, Viber and WhatsApp each opened with this: a collapsed
 * panel holding a numbered list. Telegram, Webex and the web chat instead put
 * their instructions on the page as loose centred sentences, so the same task -
 * connect a channel - looked like two different jobs depending on which tab you
 * were on, and a channel with three sentences of setup pushed everything under
 * it down the page whether or not anybody was reading them.
 *
 * The four that already had it wrote the accordion out in full, once each. This
 * is that markup, written once.
 *
 * @param steps translation keys, one per numbered step. Where a channel's
 *   instructions are prose rather than a procedure, pass `children` instead and
 *   they are placed in the same panel.
 */
const IntegrationSteps = ({steps = [], defaultOpen = false, children}) => (
    <Accordion defaultValue={defaultOpen ? '1' : null} style={{margin: '10px 0 20px 0'}}>
        <AccordionItem
            value="1"
            triggerContent={
                <span className="integration-steps">
                    <CircleQuestionMarkIcon/>
                    <Translate text="integrationSteps"/>
                </span>
            }
            triggerIcon={({isOpen}) => (
                isOpen()
                    ? <MinusIcon style={{color: colors.silverBlue}} stroke="currentColor" width={18} height={18}/>
                    : <PlusIcon style={{color: colors.silverBlue}} stroke="currentColor" width={18} height={18}/>
            )}
            itemStyle={{
                background: '#fafafa',
                borderRadius: '10px',
                padding: '12px 16px'
            }}
        >
            <div className="integration-steps__body">
                {steps.length > 0 && (
                    <ol className="integration-steps__list">
                        {steps.map(step => (
                            <li key={step}><Translate text={step}/></li>
                        ))}
                    </ol>
                )}
                {children}
            </div>
        </AccordionItem>
    </Accordion>
);

export default IntegrationSteps;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/components/IntegrationSteps.jsx